export default "https://cdn-static.gokick.com/assets/d8950a20925d8040d2b2bc8b449b43040bc9b501/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";